import { isAuthenticated, hasAccess } from '@/auth/authGuard'
import { LazyLoadView } from '@/router/utils'

export default [
  {
    name: 'products',
    path: '/products',
    component: () => LazyLoadView(import(/* webpackChunkName: "products" */ '@/views/Product/Products')),
    beforeEnter: hasAccess('products'),
  },
  {
    name: 'product-create',
    path: '/products/create',
    component: () => LazyLoadView(import(/* webpackChunkName: "product-mutate" */ '@/views/Product/Mutate.vue')),
    beforeEnter: isAuthenticated,
  },
  {
    name: 'product-edit',
    path: '/products/:id/edit',
    props: true,
    component: () => LazyLoadView(import(/* webpackChunkName: "product-mutate" */ '@/views/Product/Mutate.vue')),
    beforeEnter: isAuthenticated,
  },
  {
    name: 'product-review',
    path: '/products/review',
    props: true,
    component: () => LazyLoadView(import(/* webpackChunkName: "product-review" */ '@/views/Product/Review.vue')),
    beforeEnter: isAuthenticated,
  },
]
